import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import LoaderButton from '../loader-button/LoaderButton';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormGroup,
  CardTitle,
  Table,
  Input,
  Label,
  Alert
} from 'reactstrap';
import { FieldGroup } from '../../libs/formLib';
import Select from 'react-select';

// consts
const PERMISSION_READ = 'read';
const PERMISSION_UPDATE = 'update';

const vendorOptions = [
  { value: 'all', label: 'All vendors (current and future)' },
  { value: 'specific', label: 'Specific vendors' }
];

const featuresOptions = [
  { value: 'all', label: 'All features (current and future)' },
  { value: 'specific', label: 'Specific features' }
];

// Hardcoded features list
const availableFeatures = [{ id: 'bugscrubadvisor', name: 'Bug Scrub Advisor' }];

// const integrationOptions = [
//   { value: 'all', label: 'All integrations (current and future)' },
//   { value: 'specific', label: 'Specific integrations' }
// ];
const InputRoleModal = ({
  isReadOnly,
  modalOpen,
  setModalOpen,
  loader,
  vendors,
  selectedRole,
  createRole,
  updateRole,
  setSelectedRole,
  isSubmitted,
  setIsSubmitted
}) => {
  console.log('selectedRole', selectedRole.name);
  const [vendorMode, setVendorMode] = useState(vendorOptions[0]);
  const [featuresMode, setFeaturesMode] = useState(featuresOptions[0]);
  const [roleName, setRoleName] = useState('');
  const [defaultRole, setDefaultRole] = useState(false);
  const [vendorAllView, setVendorAllView] = useState(false);
  const [adminAllView, setAdminAllView] = useState(false);
  const [adminAllManage, setAdminAllManage] = useState(false);
  const [vendorAllManage, setVendorAllManage] = useState(false);
  const [featuresAllView, setFeaturesAllView] = useState(false);
  const [featuresAllManage, setFeaturesAllManage] = useState(false);
  const [vendorPerms, setVendorPerms] = useState({});
  const [featuresPerms, setFeaturesPerms] = useState({});
  console.log('roleName', roleName);

  const selectStyles = {
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        color: isFocused ? 'white' : isSelected ? 'white' : 'black'
      };
    }
  };

  useEffect(() => {
    // reset global switches
    setAdminAllView(false);
    setAdminAllManage(false);
    setVendorAllView(false);
    setVendorAllManage(false);
    setFeaturesAllView(false);
    setFeaturesAllManage(false);
    setVendorPerms({});
    setFeaturesPerms({});
    setVendorMode(vendorOptions[0]);
    setFeaturesMode(featuresOptions[0]);
    setRoleName(selectedRole.name);
    setDefaultRole(selectedRole.isDefault);
    selectedRole.rbacPermissions.forEach(permission => {
      /*
      {
        "id": 17,
        "entity": "cisco/*",
        "read": 0,
        "delete": 0,
        "domain": "vendor",
        "create": 1,
        "update": 1,
        "rbacRoleId": 2
      }
         */
      if (permission.domain === 'admin') {
        // Load admin permissions
        const entity = permission.entity.split('/');
        // if top level entity, set all
        if (entity.length === 1) {
          // all admin entity
          // set admin mode to all
          // set admin global permissions
          setAdminAllView(!!permission.read);
          setAdminAllManage(!!permission.update);
        }
      }

      if (permission.domain === 'vendor') {
        // Load vendor permissions
        const entity = permission.entity.split('/');
        // if top level entity, set all
        if (entity.length === 1) {
          // all vendor entity
          // set vendor mode to all
          setVendorMode(vendorOptions[0]);
          // set vendor global permissions
          setVendorAllView(!!permission.read);
          setVendorAllManage(!!permission.update);
        } else {
          //vendor specific entity
          // reset global to false for default

          const vendorId = entity[0];
          // set vendor mode to specific vendors
          setVendorMode(vendorOptions[1]);
          // set vendor permissions - create new object instead of mutating
          setVendorPerms(prev => ({
            ...prev,
            [vendorId]: {
              read: permission.read,
              update: permission.update
            }
          }));
        }
      }

      if (permission.domain === 'feature') {
        // Load features permissions
        const entity = permission.entity.split('/');
        // if top level entity, set all
        if (entity.length === 1) {
          // all features entity
          // set features mode to all
          setFeaturesMode(featuresOptions[0]);
          // set features global permissions
          setFeaturesAllView(!!permission.read);
          setFeaturesAllManage(!!permission.update);
        } else {
          // feature specific entity
          const featureId = entity[0];
          // set features mode to specific features
          setFeaturesMode(featuresOptions[1]);
          // set feature permissions - create new object instead of mutating
          setFeaturesPerms(prev => ({
            ...prev,
            [featureId]: {
              read: permission.read,
              update: permission.update
            }
          }));
        }
      }
    });
  }, [vendors, selectedRole]);
  const handleVendorModeChange = selectedOption => {
    // Reset vendor selections on mode change
    if (selectedOption.value === 'all') {
      setVendorPerms({});
    } else {
      setVendorAllView(false);
      setVendorAllManage(false);
    }
    setVendorMode(selectedOption);
  };

  const handleFeaturesModeChange = selectedOption => {
    // Reset features selections on mode change
    if (selectedOption.value === 'all') {
      setFeaturesPerms({});
    } else {
      setFeaturesAllView(false);
      setFeaturesAllManage(false);
    }
    setFeaturesMode(selectedOption);
  };

  // Handle checkboxes for vendor permissions
  const handleSetVendor = (vendorId, permission, value) => {
    setVendorPerms(prev => ({
      ...prev,
      [vendorId]: {
        ...(prev[vendorId] || {}),
        [permission]: value
      }
    }));
  };

  const handleSaveRole = async () => {
    if (roleName.length === 0) return;
    // Translate permission state for API call
    const permissions = [];
    if (adminAllView || adminAllManage) {
      // Global Admin permissions
      permissions.push({
        entity: '*',
        domain: 'admin',
        read: adminAllView,
        delete: adminAllManage,
        create: adminAllManage,
        update: adminAllManage
      });
    }
    if (vendorAllView || vendorAllManage) {
      // Global vendor permissions
      permissions.push({
        entity: '*',
        domain: 'vendor',
        read: vendorAllView,
        delete: vendorAllManage,
        create: vendorAllManage,
        update: vendorAllManage
      });
    } else {
      for (const property in vendorPerms) {
        permissions.push({
          entity: `${property}/*`,
          domain: 'vendor',
          read: !!vendorPerms[property].read,
          delete: !!vendorPerms[property].update,
          create: !!vendorPerms[property].update,
          update: !!vendorPerms[property].update
        });
      }
    }

    // Features permissions
    if (featuresAllView || featuresAllManage) {
      // Global features permissions
      permissions.push({
        entity: '*',
        domain: 'feature',
        read: featuresAllView,
        delete: featuresAllManage,
        create: featuresAllManage,
        update: featuresAllManage
      });
    } else {
      for (const property in featuresPerms) {
        permissions.push({
          entity: `${property}/*`,
          domain: 'feature',
          read: !!featuresPerms[property].read,
          delete: !!featuresPerms[property].update,
          create: !!featuresPerms[property].update,
          update: !!featuresPerms[property].update
        });
      }
    }

    const payload = {
      name: roleName,
      isDefault: defaultRole,
      rbacPermissions: permissions
    };

    if (selectedRole.id) {
      // Updating a role
      updateRole(payload);
    } else {
      // Creating a role
      createRole(payload);
    }
  };

  // Load permissions
  // iterate permissions and set vendorPermsView, vendorAllView and manage...

  return (
    <Fragment>
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)}>
        <ModalHeader>Role Creation</ModalHeader>
        <ModalBody>
          {isReadOnly && (
            <Alert color="info">
              Note: Your user only has read-only access. You will not be able to save any updates.
            </Alert>
          )}

          <FormGroup lg="5">
            <FieldGroup
              type="text"
              label="Role Name"
              id="roleName"
              onChange={e => setRoleName(e.target.value)}
              value={roleName}
              placeholder="role name..."
              help="Choose the name for your role"
              required
              feedback="Please specify a valid role name"
              showFeedback={roleName.length === 0 && isSubmitted}
              data-testid={'role-name'}
            />
          </FormGroup>
          <FormGroup check>
            <Input
              id={`default-role`}
              type="checkbox"
              checked={defaultRole}
              onChange={() => {
                setDefaultRole(!defaultRole);
              }}
              data-testid={'default-role-checkbox'}
            />
            <Label for={`default-role`} check data-testid={'default-role-label'}>
              {' '}
              Default Role
            </Label>
          </FormGroup>
          <hr />
          <CardTitle data-testid={'kw-exclude-title'}>Administrative functions</CardTitle>
          <Table bordered striped style={{ marginTop: '20px' }}>
            <thead className="card-header">
              <tr>
                <th>Name</th>
                <th>View</th>
                <th>Manage</th>
              </tr>
            </thead>
            <tbody>
              <tr id={'admin-all'} className="font-weight-bold" data-testid={'admin-all-row'}>
                <td>
                  <div className="py-2">(All)</div>
                </td>
                <td>
                  {' '}
                  <FormGroup check>
                    <Input
                      id={`admin-all-read`}
                      type="checkbox"
                      checked={adminAllView}
                      onChange={() => {
                        if (adminAllView) setAdminAllManage(false);
                        setAdminAllView(!adminAllView);
                      }}
                      data-testid={'admin-all-read-checkbox'}
                    />
                    <Label for={`admin-all-read`} check data-testid={'admin-all-read-label'}>
                      {' '}
                      View
                    </Label>
                  </FormGroup>
                </td>
                <td>
                  {' '}
                  <FormGroup check>
                    <Input
                      id={`admin-all-manage`}
                      type="checkbox"
                      checked={adminAllManage}
                      onChange={() => {
                        // if manage is enabled, also enable read.
                        if (!adminAllManage) setAdminAllView(true);
                        setAdminAllManage(!adminAllManage);
                      }}
                      data-testid={'admin-all-manage-checkbox'}
                    />
                    <Label for={`admin-all-manage`} check data-testid={'admin-all-manage-label'}>
                      {' '}
                      Manage
                    </Label>
                  </FormGroup>
                </td>
              </tr>

              <tr />
            </tbody>
          </Table>
          <hr />

          <CardTitle data-testid={'kw-exclude-title'}>Vendors</CardTitle>
          <Select
            value={vendorMode}
            onChange={handleVendorModeChange}
            options={vendorOptions}
            className="shadow"
            styles={selectStyles}
          />
          {vendorMode === vendorOptions[0] && (
            <Table bordered striped style={{ marginTop: '20px' }}>
              <thead className="card-header">
                <tr>
                  <th>Name</th>
                  <th>View</th>
                  <th>Manage</th>
                </tr>
              </thead>
              <tbody>
                <tr id={'vendor-all'} className="font-weight-bold" data-testid={'vendor-all-row'}>
                  <td>
                    <div className="py-2">(All)</div>
                  </td>
                  <td>
                    {' '}
                    <FormGroup check>
                      <Input
                        id={`vendor-all-read`}
                        type="checkbox"
                        checked={vendorAllView}
                        onChange={() => {
                          if (vendorAllView) setVendorAllManage(false);
                          setVendorAllView(!vendorAllView);
                        }}
                        data-testid={'vendor-all-read-checkbox'}
                      />
                      <Label for={`vendor-all-read`} check data-testid={'vendor-all-read-label'}>
                        {' '}
                        View
                      </Label>
                    </FormGroup>
                  </td>
                  <td>
                    {' '}
                    <FormGroup check>
                      <Input
                        id={`vendor-all-manage`}
                        type="checkbox"
                        checked={vendorAllManage}
                        onChange={() => {
                          // if manage is enabled, also enable read.
                          if (!vendorAllManage) setVendorAllView(true);
                          setVendorAllManage(!vendorAllManage);
                        }}
                        data-testid={'vendor-all-manage-checkbox'}
                      />
                      <Label for={`vendor-all-manage`} check data-testid={'vendor-all-manage-label'}>
                        {' '}
                        Manage
                      </Label>
                    </FormGroup>
                  </td>
                </tr>

                <tr />
              </tbody>
            </Table>
          )}
          {vendorMode === vendorOptions[1] && (
            <Table bordered striped style={{ marginTop: '20px' }}>
              <thead className="card-header">
                <tr>
                  <th>Name</th>
                  <th>View</th>
                  <th>Manage</th>
                </tr>
              </thead>
              <tbody>
                {vendors?.length ? (
                  vendors.map(vendor => {
                    return (
                      <tr key={vendor.id} id={vendor.id} className="font-weight-bold" data-testid={'vendor-row'}>
                        <td>
                          <div className="py-2">{vendor.name}</div>
                        </td>
                        <td>
                          {' '}
                          <FormGroup check>
                            <Input
                              id={`vendor-read-${vendor.id}`}
                              type="checkbox"
                              checked={!!vendorPerms[vendor.id]?.read}
                              onChange={() => {
                                if (vendorPerms[vendor.id]?.read) handleSetVendor(vendor.id, PERMISSION_UPDATE, false);
                                handleSetVendor(vendor.id, PERMISSION_READ, !vendorPerms[vendor.id]?.read);
                              }}
                              data-testid={'vendor-read-checkbox'}
                            />
                            <Label for={`vendor-read-${vendor.id}`} check data-testid={'vendor-all-read-label'}>
                              {' '}
                              View
                            </Label>
                          </FormGroup>
                        </td>
                        <td>
                          {' '}
                          <FormGroup check>
                            <Input
                              id={`vendor-manage-${vendor.id}`}
                              type="checkbox"
                              checked={!!vendorPerms[vendor.id]?.update}
                              onChange={() => {
                                if (!vendorPerms[vendor.id]?.update) handleSetVendor(vendor.id, PERMISSION_READ, true);
                                handleSetVendor(vendor.id, PERMISSION_UPDATE, !vendorPerms[vendor.id]?.update);
                              }}
                              data-testid={'vendor-manage-checkbox'}
                            />
                            <Label for={`vendor-manage-${vendor.id}`} check data-testid={'vendor-all-manage-label'}>
                              {' '}
                              Manage
                            </Label>
                          </FormGroup>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr className="font-weight-bold">
                    <td>No vendors found.</td>
                    <td />
                    <td />
                  </tr>
                )}

                <tr />
              </tbody>
            </Table>
          )}
          <hr />

          <CardTitle data-testid={'features-title'}>Features</CardTitle>
          <Select
            value={featuresMode}
            onChange={handleFeaturesModeChange}
            options={featuresOptions}
            className="shadow"
            styles={selectStyles}
          />
          {featuresMode === featuresOptions[0] && (
            <Table bordered striped style={{ marginTop: '20px' }}>
              <thead className="card-header">
                <tr>
                  <th>Name</th>
                  <th>View</th>
                  <th>Manage</th>
                </tr>
              </thead>
              <tbody>
                <tr id={'features-all'} className="font-weight-bold" data-testid={'features-all-row'}>
                  <td>
                    <div className="py-2">(All)</div>
                  </td>
                  <td>
                    {' '}
                    <FormGroup check>
                      <Input
                        id={`features-all-read`}
                        type="checkbox"
                        checked={featuresAllView}
                        onChange={() => {
                          if (featuresAllView) setFeaturesAllManage(false);
                          setFeaturesAllView(!featuresAllView);
                        }}
                        data-testid={'features-all-read-checkbox'}
                      />
                      <Label for={`features-all-read`} check data-testid={'features-all-read-label'}>
                        {' '}
                        View
                      </Label>
                    </FormGroup>
                  </td>
                  <td>
                    {' '}
                    <FormGroup check>
                      <Input
                        id={`features-all-manage`}
                        type="checkbox"
                        checked={featuresAllManage}
                        onChange={() => {
                          if (!featuresAllManage) setFeaturesAllView(true);
                          setFeaturesAllManage(!featuresAllManage);
                        }}
                        data-testid={'features-all-manage-checkbox'}
                      />
                      <Label for={`features-all-manage`} check data-testid={'features-all-manage-label'}>
                        {' '}
                        Manage
                      </Label>
                    </FormGroup>
                  </td>
                </tr>

                <tr />
              </tbody>
            </Table>
          )}
          {featuresMode === featuresOptions[1] && (
            <Table bordered striped style={{ marginTop: '20px' }}>
              <thead className="card-header">
                <tr>
                  <th>Name</th>
                  <th>View</th>
                  <th>Manage</th>
                </tr>
              </thead>
              <tbody>
                {availableFeatures?.length ? (
                  availableFeatures.map(feature => {
                    return (
                      <tr key={feature.id} id={feature.id} className="font-weight-bold" data-testid={'feature-row'}>
                        <td>
                          <div className="py-2">{feature.name}</div>
                        </td>
                        <td>
                          {' '}
                          <FormGroup check>
                            <Input
                              id={`feature-${feature.id}-read`}
                              type="checkbox"
                              checked={!!featuresPerms[feature.id]?.read}
                              onChange={() => {
                                if (featuresPerms[feature.id]?.read) {
                                  setFeaturesPerms({
                                    ...featuresPerms,
                                    [feature.id]: {
                                      ...featuresPerms[feature.id],
                                      read: false,
                                      update: false
                                    }
                                  });
                                } else {
                                  setFeaturesPerms({
                                    ...featuresPerms,
                                    [feature.id]: {
                                      ...featuresPerms[feature.id],
                                      read: true
                                    }
                                  });
                                }
                              }}
                              data-testid={`feature-${feature.id}-read-checkbox`}
                            />
                            <Label
                              for={`feature-${feature.id}-read`}
                              check
                              data-testid={`feature-${feature.id}-read-label`}
                            >
                              {' '}
                              View
                            </Label>
                          </FormGroup>
                        </td>
                        <td>
                          {' '}
                          <FormGroup check>
                            <Input
                              id={`feature-${feature.id}-manage`}
                              type="checkbox"
                              checked={!!featuresPerms[feature.id]?.update}
                              onChange={() => {
                                if (!featuresPerms[feature.id]?.update) {
                                  setFeaturesPerms({
                                    ...featuresPerms,
                                    [feature.id]: {
                                      ...featuresPerms[feature.id],
                                      read: true,
                                      update: true
                                    }
                                  });
                                } else {
                                  setFeaturesPerms({
                                    ...featuresPerms,
                                    [feature.id]: {
                                      ...featuresPerms[feature.id],
                                      update: false
                                    }
                                  });
                                }
                              }}
                              data-testid={`feature-${feature.id}-manage-checkbox`}
                            />
                            <Label
                              for={`feature-${feature.id}-manage`}
                              check
                              data-testid={`feature-${feature.id}-manage-label`}
                            >
                              {' '}
                              Manage
                            </Label>
                          </FormGroup>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr className="font-weight-bold">
                    <td>You have no features available yet</td>
                    <td />
                    <td />
                  </tr>
                )}

                <tr />
              </tbody>
            </Table>
          )}
        </ModalBody>
        <ModalFooter>
          <>
            <Button color="falcon-danger" onClick={() => setModalOpen(!modalOpen)} data-testid={'cancel-btn'}>
              Cancel
            </Button>
            <LoaderButton
              disabled={roleName.length === 0 || isReadOnly}
              color="falcon-primary"
              onClick={handleSaveRole}
              isLoading={loader}
              name="save-and-add"
              size="sm"
            >
              {selectedRole.id ? 'Update role' : 'Create role'}
            </LoaderButton>
          </>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

InputRoleModal.propTypes = {
  isLoading: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  handleSave: PropTypes.func,
  vendors: PropTypes.array,
  setModalOpen: PropTypes.func,
  modalOpen: PropTypes.bool,
  createRole: PropTypes.func,
  updateRole: PropTypes.func,
  loader: PropTypes.bool,
  cta: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isSubmitted: PropTypes.bool,
  selectedRole: PropTypes.object,
  setRoleName: PropTypes.func,
  setIsSubmitted: PropTypes.func,
  setSelectedRole: PropTypes.func
};

export default InputRoleModal;
